import { Collapse } from "antd";
import { useMemo, useState } from "react";

const FAQ = () => {
  const faqItems = [
    {
      key: "1",
      label: "How recent are these leads?",
      children: (
        <p>
          Very recent. Each week GoLeads updates the files, and best of all, when you order a
state and pay the monthly fee, GoLeads will automatically send you the new, updated
list. This way, you always have the most recent list of brand new businesses.
        </p>
      ),
    },
    {
      key: "2",
      label: "Are these leads exclusive to me?",
      children: (
        <p>
          No, the information comes in a list format, and there may be other people who are
working the same businesses, so don’t wait. Download your state today and work the
list before your competiton gets to it. If you want exclusive leads, call GoLeads today at
402-334-1824 and ask about our Qualified Lead Generation Program.
        </p>
      ),
    },
    {
      key: "3",
      label: "What information comes with each lead?",
      children: (
        <p>
          Because these businesses are so new, very little is known about them. Information that
is known is phone number, company name, and address.
        </p>
      ),
    },
    {
      key: "4",
      label: "Can I choose the area I want the businesses to located?",
      children: (
        <p>
          Yes. Pick and pay for the entire state and you will get an updated list of brand new
businesses in the state EVERY single week.
        </p>
      ),
    },
    {
      key: "5",
      label: "What kind of businesses are on the list?",
      children: (
        <p>
          All kinds – covering numerous industries. Lists are ideal for equipment, phones,
internet, supplies, furniture, and more.
        </p>
      ),
    },
    {
      key: "6",
      label: "How is the data collected?",
      children: (
        <p>
         After 25 years, GoLeads knows who the best compilers are when it comes to creating databases of brand new businesses and new business line connections.
        </p>
      ),
    },
    {
      key: "7",
      label: "Can I use the leads more than once?",
      children: (
        <p>
          Yes, you can filter by company size based on number of employees,
          square footage, or annual revenue. This helps you target businesses
          that match your service capacity and pricing structure.
        </p>
      ),
    },
    {
      key: "8",
      label: "What’s the best way to reach these businesses?",
      children: (
        <p>
         By phone and by direct mail. Again, since little is known about these businesses,
GoLeads is not able to provide email addresses. If you’re looking for a list with more
information on each business, call GoLeads at 402-334-1824 and someone can help
you with a list of more established businesses with more information.
        </p>
      ),
    },
    {
      key: "9",
      label: "What kind of results should I expect?",
      children: (
        <p>
          That’s always hard to say since so much is dependent upon the amount of time you put
into calling the businesses and following up. The more time you give to prospecting the
better.
        </p>
      ),
    },
    {
      key: "10",
      label: "What happens if the information is wrong?",
      children: (
        <p>
          It will happen – very few times compared to the number of times the data is good. Work
the list and see your customer base grow.
        </p>
      ),
    },
  ];
  const { Panel } = Collapse;
  const [openKey, setOpenKey] = useState(); // shared across both columns

  const { leftItems, rightItems } = useMemo(() => {
    const mid = Math.ceil(faqItems.length / 2);
    return {
      leftItems: faqItems.slice(0, mid),
      rightItems: faqItems.slice(mid),
    };
  }, []);

  const renderItem = (item) => (
    <div
      key={item.key}
      className="bg-[#E3E3E3] shadow-sm border-1 border-[#F09900]"
    >
      <Collapse
        accordion
        ghost
        expandIconPosition="end"
        activeKey={openKey === item.key ? item.key : undefined}
        onChange={(key) => {
          setOpenKey(key || undefined);
        }}
        items={[
          {
            key: item.key,
            label: <span className="text-[#1465B7] text-lg">{item.label}</span>,
            children: (
              <div className="text-gray-600 text-base leading-relaxed">
                {item.children}
              </div>
            ),
          },
        ]}
        className="bg-[#E4F7F9] rounded-lg"
      />
    </div>
  );

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-4">
          <p className="text-2xl text-[#4D6877] font-semibold">Frequently Asked Question</p>
        </div>
        <div className="mx-auto">
          <div className="px-5 md:px-0 grid grid-cols-1 md:grid-cols-2 auto-rows-min items-start mt-6">
            <div>{leftItems.map((item) => renderItem(item))}</div>
            <div>{rightItems.map((item) => renderItem(item))}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
